const FloorplanFurniture = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');

    const handleResize = () => {
      if (!mediaQuery.matches) {
        // If screen width is less than 1024px, clear styles
        const floorPlansWrapToggle = document.querySelector(
          '.floorplans__wrap--toggle'
        );
        if (floorPlansWrapToggle) {
          floorPlansWrapToggle.style.width = '';
        }
        return; // Skip execution below 1024px
      }

      // Active logic for 1024px and higher
      const floorPlanImage = document.querySelector('.floorplan__image-link');
      const floorPlansWrapToggle = document.querySelector(
        '.floorplans__wrap--toggle'
      );

      const updateWidths = () => {
        setTimeout(() => {
          if (floorPlanImage && floorPlansWrapToggle) {
            const { width } = floorPlanImage.getBoundingClientRect();
            floorPlansWrapToggle.style.width = `${width}px`;
          }
        }, 800); // Delay to allow page to render
      };

      let resizeTimeout;

      // Listener for resize with delay
      window.addEventListener('resize', () => {
        if (!mediaQuery.matches) return; // Skip logic if less than 1024px
        clearTimeout(resizeTimeout); // Clear any existing timeout
        resizeTimeout = setTimeout(() => {
          updateWidths(); // Update width after user stops resizing
        }, 200); // Adjust delay time as needed
      });

      // Initial width sync on page load
      updateWidths();
    };

    // Run once on load
    handleResize();

    // Listen for screen size changes
    mediaQuery.addEventListener('change', handleResize);

    // Toggle logic (applies at all sizes but can restrict as needed)
    const toggleSwitch = document.getElementById('toggle-switch');
    if (toggleSwitch) {
      toggleSwitch.checked = false;

      toggleSwitch.addEventListener('change', () => {

        // Add delay before executing the logic
        setTimeout(() => {
          const floorplans = document.querySelectorAll('.floorplans__images');
          const floorplansFurniture = document.querySelectorAll(
            '.floorplans__images--furniture'
          );

          if (toggleSwitch.checked) {
            // Hide all floorplans and show all furniture elements
            floorplans.forEach((element) => {
              element.style.display = 'none';
            });
            floorplansFurniture.forEach((element) => {
              element.style.display = 'block';
            });
          } else {
            // Show all floorplans and hide all furniture elements
            floorplans.forEach((element) => {
              element.style.display = 'block';
            });
            floorplansFurniture.forEach((element) => {
              element.style.display = 'none';
            });
          }
        });
      });
    }
  });
};

export default FloorplanFurniture;
